type FormatPriceToTengeOptions = {
    currency?: string
    withDecimals?: boolean
    decimals?: number
}

export default function formatPriceToTenge(
    value: number | string | null | undefined,
    options: FormatPriceToTengeOptions = {}
): string | null {
    if (value === null || value === undefined || value === '') return null

    const numberValue =
        typeof value === 'number'
            ? value
            : Number(String(value).replace(/\s/g, ''))

    if (isNaN(numberValue)) return String(value)

    const {
        currency = '₸',
        withDecimals = false,
        decimals = 2
    } = options

    const formatted = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: withDecimals ? decimals : 0,
        maximumFractionDigits: withDecimals ? decimals : 0
    }).format(numberValue)

    return currency ? `${formatted} ${currency}` : formatted
}
